+function($, window, document) {
	'use strict';
	
	var CategoryMenus = function(element, options) {
		this.options = options;
		this.$element = $(element);
		this.$menus = this.$element.find('dd');
		this.isTouch = false;
		
		this.initialize();
	};
	
	CategoryMenus.DEFAULTS = {
		initShow: false
	};
	
	CategoryMenus.prototype.initialize = function() {
		this.detectDevice();
		
		if (!this.isTouch && this.options.initShow) {
			this.$menus.show();
		}
		
		this.observeTrigger();
	};
	
	CategoryMenus.prototype.detectDevice = function() {
		if ($(window).width() < 992) {
			this.isTouch = true;
			
			this.$menus.css('width', this.$element.width());
		}else {
			this.$menus.css('width', this.$element.width() - 1);
		}
	};
	
	CategoryMenus.prototype.observeTrigger = function() {
		var scope = this;
		
		if (this.isTouch) {
			var hammer = new Hammer(this.$element[0]);
			
			hammer.on('tap', function(event) {
				var target = $(event.target);
				
				if (target.is('dt')) {
					scope.$menus.toggle();
				}
			});
		}else {
			if ( ! this.options.initShow) {
				this.$element.on('mouseover', function(event) {
					scope.$menus.show();
					
					return false;
				});
				
				this.$element.on('mouseleave', function() {
					scope.$menus.hide();
					
					return false;
				});
			}
		}
	};
	
	function Plugin(option) {
	    return this.each(function () {
    		var $this   = $(this),
    			data    = $this.data('sn.CategoryMenus'),
    			options = $.extend({}, CategoryMenus.DEFAULTS, typeof option == 'object' && option);
	      
	      if ( ! data) {
	    	  $this.data('sn.CategoryMenus', (data = new CategoryMenus(this, options)));  
	      } 
	      
	      if (typeof option == 'string') {
	    	  data[option]();  
	      } 
	    });
	}
	
	var old = $.fn.FiltersList;
	
	$.fn.CategoryMenus = Plugin;
	$.fn.CategoryMenus.Constructor = CategoryMenus;
	
	$.fn.CategoryMenus.noConflict = function () {
	    $.fn.CategoryMenus = old;
	    return this;
	};
}(jQuery, window, document);